<template>
  <div>
    <h1>Загрузите выписку (xlsx)</h1>
    <input type="file" @change="handleFileUpload"/>
    <select v-model="currency">
      <option disabled value="">Выберите валюту</option>
      <option>RUB</option>
      <option>UZS</option>
      <option>EUR</option>
      <option>USD</option>
    </select>
    <button @click="submitFile">Отправить</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedFile: null,
      currency: ''
    };
  },
  methods: {
    handleFileUpload(event) {
      this.selectedFile = event.target.files[0];
    },
    async submitFile() {
      if (!this.selectedFile || !this.currency) {
        alert('Пожалуйста, выберите файл и валюту.');
        return;
      }

      let formData = new FormData();
      formData.append('file', this.selectedFile);
      formData.append('currency', this.currency);

      try {
        const response = await fetch(`${process.env.VUE_APP_BACKEND_API_URL}/api/parse_excel`, {
          method: 'POST',
          body: formData,
        });

        if (!response.ok) throw new Error('Ошибка сервера');

        // console.log(response.json());
        // return;

        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = "processed_file.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
      } catch (error) {
        console.error('Ошибка:', error);
      }
    }
  }
};
</script>

<style scoped>
div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #f9f9f9;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  margin: 50px auto auto;
}

h1 {
  color: #333;
  margin-bottom: 20px;
}

input[type="file"] {
  margin-bottom: 20px;
  cursor: pointer;
  padding: 8px 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: white;
  width: 100%;
  box-sizing: border-box;
  text-overflow: ellipsis;
}

select {
  padding: 8px 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: white;
  margin-bottom: 20px;
  cursor: pointer;
}

button {
  padding: 10px 20px;
  color: white;
  background-color: #007bff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

button:hover {
  background-color: #0056b3;
}

button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
</style>
